export interface WaggleLogInterface {
  /**
   * 本次摇号ID
   */
  waggleId: number
  taskId: number
  /**
   * 本次摇号时间
   */
  waggledAt: string
  /**
   * 本次中签数量
   */
  quota: number
  /**
   * 本次参与人数
   */
  count: number
}

export class WaggleLog implements WaggleLogInterface {
  /**
   * 本次摇号ID
   */
  waggleId: number
  taskId: number
  /**
   * 本次摇号时间
   */
  waggledAt: string
  /**
   * 本次中签数量
   */
  quota: number
  /**
   * 本次参与人数
   */
  count: number

  constructor(props: WaggleLogInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      waggleId: _waggleId,
      taskId: _taskId,
      waggledAt: _waggledAt,
      quota: _quota,
      count: _count,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.waggleId = _waggleId
    this.taskId = _taskId
    this.waggledAt = _waggledAt
    this.quota = _quota
    this.count = _count
  }
}
